import { ClipboardTextIcon } from '@phosphor-icons/react';
import { PageTitle } from '@/components';
import {
    type ReportPipelineStatus,
    type ReportWithEvents,
} from '@/types/report';
import { ProcedureStatusCard } from './ProcedureStatusCard/ProcedureStatusCard';

interface ReportDetailHeaderProps {
    isInitialLoading: boolean;
    report: ReportWithEvents | undefined;
    isProcedureReport: boolean;
    pipelineStatus: ReportPipelineStatus | undefined;
    pipelineStatusError: Error | undefined;
}

export function ReportDetailHeader({
    isInitialLoading,
    report,
    isProcedureReport,
    pipelineStatus,
    pipelineStatusError,
}: ReportDetailHeaderProps) {
    if (isInitialLoading) {
        return (
            <div className="h-16 w-2/3 max-w-md rounded-lg bg-grey-600 animate-pulse" />
        );
    }

    if (!report) {
        return null;
    }

    return (
        <div className="pb-4 shrink-0 min-w-0 pt-4">
            <PageTitle
                icon={<ClipboardTextIcon />}
                text={report.name}
                allowRename={false}
            />
            {report.description ? (
                <p className="text-md text-grey-100 mt-1 whitespace-pre-wrap">
                    {report.description}
                </p>
            ) : null}
            {isProcedureReport ? (
                <ProcedureStatusCard
                    reportId={report.id}
                    pipelineStatus={pipelineStatus}
                    pipelineStatusError={pipelineStatusError}
                />
            ) : null}
        </div>
    );
}
